import type React from 'react';

import cn from 'classnames';
import getMonth from 'date-fns/getMonth';

import * as st from './styles.module.scss';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	date: Date;
	selectedDate: Date;
	children: React.ReactNode;
}

export const Day: React.FC<Props> = ({ date, selectedDate, children, ...props }) => {
	const hideDay = getMonth(date) !== getMonth(selectedDate);

	return (
		<button className={cn(st.day, hideDay && st.hidden)} {...props}>
			{children}
		</button>
	);
};
